import React from "react";
import { makeStyles, createStyles } from "@material-ui/styles";
import { Text } from "../Ui/Text";
import { IEnvironment } from "../../interface/IShareInfo";

const useStyles = makeStyles(({  }) => {
  return createStyles({
    footer: {},
    footerHeading: {
      fontSize: 12,
      fontWeight: 700,
      letterSpacing: 1.02,
      marginLeft: 10,
      marginRight: 10,
      marginBottom: 20
    },
    footerParagraph: {
      fontSize: 12,
      marginBottom: 10,
      lineHeight: 1.2,
      textAlign: "justify",
      marginLeft: 10,
      marginRight: 10
    }
  });
});

const Footer = (env: IEnvironment) => {
  const classes = useStyles({});

  return (
    <footer className={classes.footer}>
      <Text variant="body2" className={classes.footerHeading}>
        {env.COMPANY_INFO}
      </Text>
      <Text variant="body2" className={classes.footerParagraph}>
        Each mobile ticket has a unique bar code. This bar code allows one entry
        only so please ensure that each individual attending the event has his
        or her own mobile ticket.
      </Text>
      <Text variant="body2" className={classes.footerParagraph}>
        Do not give a copy of your mobile ticket to anyone and do not buy a
        mobile ticket except from Ticketek's website, mobile site, call centre
        or agencies. If there are multiple copies of a mobile ticket, only the
        1st copy to be scanned on arrival at the event will allow the ticket
        holder entry. Additional copies subsequently scanned will result in our
        system displaying the message 'Second Entry' (or similar) and entry may
        be denied.
      </Text>
      <Text variant="body2" className={classes.footerParagraph}>
        Do not buy mobile tickets from. If an unauthorised seller scalper has
        distributed multiple copies of a single ticket you may be refused entry.
      </Text>
      <Text variant="body2" className={classes.footerParagraph}>
        Tickets are sold by Ticketek as agent for the venue, promoter or person
        responsible for holding the relevant event (the "Seller"). This ticket
        is sold subject to Ticketek's Terms and Conditions which apply to both
        the original purchaser and any subsequent ticketholder. Ticketek's Terms
        and Conditions are available to be viewed at ticketek.com.au.
      </Text>
      <Text variant="body2" className={classes.footerParagraph}>
        Each ticket is also sold subject to any additional terms and conditions
        of the Seller for the particular event ("Seller's Terms"). The Seller's
        Terms may be disclosed as part of the event information on Ticketek's
        website and at Ticketek agents and outlets at the time of purchase.
      </Text>
      <Text variant="body2" className={classes.footerParagraph}>
        Tickets may not, without the prior written consent of Ticketek and the
        Seller, be resold or offered for resale at a premium (including via
        on-line auction or other unauthorised resale sites) or used for
        advertising, promotion or other commercial purposes (including
        competitions and trade promotions) or to enhance the demand for other
        goods or services. If a ticket is sold or used in breach of this
        condition, the ticket may be cancelled without a refund and the
        ticketholder may be refused admission. Ticketek and/or the Seller will
        take all reasonable steps to notify you of Ticketek's intention to
        cancel the ticket or render it invalid within a reasonable time before
        cancelling it or rendering it invalid.
      </Text>
      <Text variant="body2" className={classes.footerParagraph}>
        SCALPING WARNING: The resale of tickets in certain circumstances is
        governed by ticket sales legislation and may attract criminal penalties.
      </Text>
    </footer>
  );
};

export { Footer };
